import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import LandingAnalyticsSection from "../components/LandingAnalyticsSection";
import LandingPlatformSection from "../components/LandingPlatformSection";
import LandingAudienceSection from "../components/LandingAudienceSection";
import LandingProductsTabs from "../components/LandingProductsTabs";
import LandingPricingSection from "../components/LandingPricingSection";
import LandingComparisonSection from "../components/LandingComparisonSection";
import LandingHeroPhone from "../components/LandingHeroPhone";
import LandingFooter from "../components/LandingFooter";
import LandingStickyCta from "../components/LandingStickyCta";
import LandingSectionHeader from "../components/LandingSectionHeader";
import {
  MessengerBrandInline,
  MessengerBrandStack,
} from "../components/MessengerBrandIcons";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

const STORIES = [
  {
    segment: "Кофейня · HoReCa",
    tool: "База знаний",
    story:
      "На вечерней смене гость сказал, что кофе испорчен. Новый бариста растерялся — открыл бота и за секунду нашёл, как правильно ответить. Смена прошла без эскалации.",
    result:
      "Наставник не успевал бегать между стойками — база знаний закрыла типовые конфликтные ситуации на смене.",
  },
  {
    segment: "Сеть магазинов · ритейл",
    tool: "Сценарий",
    story:
      "Каждый новый продавец проходил одну программу: возврат, касса, работа с жалобами. Руководитель сети наконец получил одинаковое качество сервиса во всех точках.",
    result:
      "Онбординг перестал зависеть от того, кто наставник в конкретном магазине.",
  },
  {
    segment: "Отдел продаж · B2B",
    tool: "Тренажёр",
    story:
      "После обновления линейки продуктов менеджеры прошли тренажёр за вечер. Руководитель сразу увидел, кто готов к встречам, а кому нужна дополнительная сессия.",
    result:
      "Проверка знаний без очных тестов и таблиц в Excel — результат виден сразу.",
  },
  {
    segment: "Служба поддержки",
    tool: "База знаний + Сценарий",
    story:
      "Операторы перестали писать в общий чат «а что ответить клиенту?». Типовые кейсы — в базе знаний, сложные — отработали в сценарии до выхода на линию.",
    result:
      "Нагрузка на тимлида снизилась, время ответа клиенту — тоже.",
  },
  {
    segment: "Склад · производство",
    tool: "Сценарий",
    story:
      "Ввели новое оборудование — похожее на старое, но с другими правилами безопасности. Сценарий помог отработать действия до выхода на смену, включая нестандартные ситуации.",
    result:
      "Меньше ошибок в первые недели после изменений — команда была готова заранее.",
  },
  {
    segment: "Монтаж · выездные бригады",
    tool: "База знаний",
    story:
      "На объекте монтажник забыл схему подключения блока питания. Вместо звонка прорабу открыл бота в Telegram — за полминуты нашёл видео-инструкцию и продолжил работу.",
    result:
      "Меньше простоя на объекте: подсказка всегда в кармане, даже когда связь с офисом нестабильна.",
  },
];

export default function MainPage() {
  return (
    <div className="landing landing--pattern">
      <section className="landing-hero landing-hero--mesh landing-hero--split">
        <div className="landing-hero__layout">
          <div className="landing-hero__content">
            <p className="landing-hero__brand">InChat</p>
            <h1 className="landing-hero__title">
              Обучение команды в Telegram и MAX
            </h1>
            <p className="landing-hero__subtitle">
              Интерактивные сценарии, база знаний и тренажёр с рейтингом — там,
              где сотрудники уже каждый день. Обучение и развитие в игровой
              форме, без отдельных приложений и сложных LMS.
            </p>
            <p className="landing-hero__channels">Доступно в Telegram и MAX</p>
            <div className="landing-hero__messengers">
              <MessengerBrandInline size={34} spaced />
            </div>
            <div className="landing-hero__trial">
              <span className="landing-hero__trial-badge">14 дней бесплатно</span>
              <p className="landing-hero__trial-text">
                Триал тарифа «Микрокоманда» после регистрации — публикация
                проектов и доступ для команды до 15 человек. Без карты и
                автопродления.
              </p>
            </div>
            <div className="landing-hero__actions">
              <Link to="/login?tab=register">
                <Button
                  variant="contained"
                  size="large"
                  className="landing-hero__btn-primary"
                >
                  Начать триал
                </Button>
              </Link>
              <a href="#pricing">
                <Button
                  variant="outlined"
                  size="large"
                  className="landing-hero__btn-secondary"
                >
                  Тарифы
                </Button>
              </a>
            </div>
          </div>
          <LandingHeroPhone />
        </div>
      </section>

      <LandingPlatformSection />

      <LandingAudienceSection />

      <LandingProductsTabs />

      <section
        id="launch"
        className="landing-band landing-band--launch landing-section landing-section--steps"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="04 · Запуск"
            title="Четыре шага до запуска в мессенджере"
            desc="От выбора инструмента до ссылки для команды — без программистов и сложных интеграций."
          />
          <div className="landing-band__panel landing-band__panel--launch">
            <div className="landing-launch landing-launch--timeline-only">
              <div className="landing-launch__timeline">
                <CustomizedTimeline />
              </div>
              <aside className="landing-launch__aside">
                <div className="landing-launch__highlights">
                  <div className="landing-intro__highlight">
                    <strong>Три инструмента</strong> — база знаний, сценарий, тренажёр
                  </div>
                  <div className="landing-intro__highlight landing-intro__highlight--messengers">
                    <span className="landing-intro__highlight-text">
                      <strong>Telegram или MAX</strong> — прохождение там, где люди
                      уже каждый день
                    </span>
                    <MessengerBrandStack size={30} />
                  </div>
                  <div className="landing-intro__highlight">
                    <strong>Без лишней возни</strong> — редактор, контент, ссылка
                    для команды, запуск
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </section>

      <LandingPricingSection />

      <LandingComparisonSection />

      <LandingAnalyticsSection />

      <section
        id="cases"
        className="landing-band landing-band--cases landing-section landing-section--usecases"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="08 · Примеры"
            title="Как инструменты InChat помогают в реальной работе"
            desc="Ситуации из разных отраслей — когда база знаний, сценарий или тренажёр решают конкретную задачу команды."
          />
          <div className="landing-band__panel landing-band__panel--cases">
            <div className="landing-stories">
              {STORIES.map(({ segment, tool, story, result }) => (
                <article className="landing-story-card" key={segment}>
                  <div className="landing-story-card__meta">
                    <span className="landing-story-card__segment">{segment}</span>
                    <span className="landing-story-card__tool">{tool}</span>
                  </div>
                  <blockquote className="landing-story-card__quote">{story}</blockquote>
                  <p className="landing-story-card__result">{result}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="landing-cta">
        <h2 className="landing-cta__title">
          Запустите обучение, базу знаний или тренажёр для команды
        </h2>
        <div className="landing-cta__messengers">
          <MessengerBrandInline size={36} spaced />
        </div>
        <p className="landing-cta__desc">
          Создайте аккаунт — 14 дней триала уже включены.{" "}
          <a href="#pricing" className="landing-cta__pricing-link">
            Посмотреть тарифы
          </a>
          . Опубликуйте проект и отправьте ссылку: команда получит обучение в
          Telegram или MAX.
        </p>
        <div className="landing-cta__actions">
          <Link to="/login?tab=register">
            <Button
              variant="contained"
              size="large"
              className="landing-hero__btn-primary"
            >
              Начать триал
            </Button>
          </Link>
        </div>
      </section>

      <section
        id="faq"
        className="landing-band landing-band--faq landing-faq landing-section--faq"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="09 · Вопрос-ответ"
            title="Частые вопросы"
            desc="О платформе, подписке и запуске программ для команд"
          />
          <div className="landing-band__panel landing-band__panel--faq">
            <AccordionComponent />
          </div>
        </div>
      </section>

      <LandingFooter />
      <LandingStickyCta />
    </div>
  );
}
